import { useMutation, useQueryClient } from "@tanstack/react-query";
import { myAccountApi } from "@/features/my-account/api";
import { UpdateFavSkusRequest } from "@/features/my-account/types";

const useUpdateFavSkus = (buyer_id?: number) => {
  const queryClient = useQueryClient();
  const { mutate: mutateFavSkus } = useMutation({
    mutationKey: ["updateFavSkus", buyer_id],
    mutationFn: (favSkus: UpdateFavSkusRequest) =>
      myAccountApi.updateFavSkus(favSkus, buyer_id),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["my-account", "favSkus", buyer_id],
      });
      queryClient.removeQueries({
        queryKey: ["my-account", "searched-skus", buyer_id],
      });
    },
  });

  return {
    mutateFavSkus,
  };
};

export default useUpdateFavSkus;
